"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/testimonailSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode, useState, useEffect, useRef } from "react";

type TestimonailSectionTestimonialElevensItem = {
    key: Key | null | undefined;
    /** Detected variants: "Fast & Reliable Reports" | "Natural Results & Professional Care" | "Confidence Restored" | "Exceptional Care & Outstanding Results" | "Subtle & Beautiful Transformation" */
    h30Text: ReactNode;
    /** Detected variants: "“I was initially nervous, but the surgeons patiently explained every step with clarity and reassurance, helping me feel calm and confident. Throughout the entire process, they made sure I was comfortable and well-informed..”" | "“I had an amazing experience from consultation to recovery. The surgeon listened carefully to my concerns and delivered results that look completely natural. I feel more confident every day and truly appreciate the professionalism..”" | "“This surgery changed my life in the best way possible. The doctor explained the procedure clearly and made me feel comfortable throughout. The results exceeded my expectations, and my confidence has improved tremendously.”" | "“The staff was incredibly supportive, and the surgeon’s attention to detail was exceptional. The results are exactly what I hoped for—balanced and natural. I highly recommend this clinic to anyone considering cosmetic surgery.”" | "“I’m extremely happy with my hair transplant results. The process was smooth, recovery was quick, and the outcome looks very natural. The team guided me through every step with care and transparency.”" */
    p0Text: ReactNode;
    /** Detected variants: "John Doe" | "Emily Richardson" | "Michael Joshua" | "Sophia Daniel" | "Daniel Anderson" */
    h40Text: ReactNode;
    /** Detected variants: "Body Contouring" | "Rhinoplasty" | "Gynecomastia Surgery" | "Liposuction" | "Hair Transplant" */
    span0Text: ReactNode;
    /** Detected variants: "testimonial-item-eleven" */
    className?: string;
    /** Detected variants: "testimonial-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "author-name" */
    div2ClassName?: string;
    /** Detected variants: "author" */
    h40ClassName?: string;
    /** Detected variants: "designation" */
    span0ClassName?: string;
    ratingItems?: TestimonailSectionFaSolidFaStarFilled1sItem[];
};

type TestimonailSectionFaSolidFaStarFilled1sItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star filled me-1" | "fa-solid fa-star filled" */
    className: string;
};

type TestimonailSectionAuthorsItem = {
    key: Key | null | undefined;
    /** Detected variants: "slide-img-1" | "slide-img-2" | "slide-img-3" | "slide-img-4" | "slide-img-5" | "slide-img-6" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/patients/patient24.jpg" | "/Templates/Doccure/img/patients/patient26.jpg" | "/Templates/Doccure/img/patients/patient21.jpg" | "/Templates/Doccure/img/patients/patient25.jpg" | "/Templates/Doccure/img/patients/patient27.jpg" | "/Templates/Doccure/img/patients/patient23.jpg" */
    src: string;
    /** Detected variants: "author-img" */
    className?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};
export type HomeElevenTestimonailSectionGeneratedProps = {
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonailSectionTestimonialElevensItem) => Partial<ComponentProps<"h3">>);
    divDiv2H40H4Props?: Partial<ComponentProps<"h4">> | ((item: TestimonailSectionTestimonialElevensItem) => Partial<ComponentProps<"h4">>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonailSectionAuthorsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Testimonials" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-left.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "arrow" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-right.svg" */
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our Testimonials" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "icon" */
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/qutation-icon.png" */
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "author" */
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/reviews/author-3.png" */
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/testimonial-img.png" */
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div1Div1Div0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    sectionDiv0Div1Div1Div0Slider1SliderProps?: Partial<ComponentProps<typeof Slider>>;
    testimonailSectionTestimonialElevens: TestimonailSectionTestimonialElevensItem[];
    testimonailSectionAuthors: TestimonailSectionAuthorsItem[];
    testimonailSectionTestimonialElevensItemWrapper?: (item: TestimonailSectionTestimonialElevensItem, content: ReactNode) => ReactNode;
    testimonailSectionTestimonialElevensRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonailSectionTestimonialElevensH3Visible?: boolean;
    testimonailSectionTestimonialElevensH3Renderer?: (item: TestimonailSectionTestimonialElevensItem, defaultNode: ReactNode) => ReactNode;
    testimonailSectionTestimonialElevensH4Visible?: boolean;
    testimonailSectionTestimonialElevensH4Renderer?: (item: TestimonailSectionTestimonialElevensItem, defaultNode: ReactNode) => ReactNode;
    testimonailSectionTestimonialElevensH3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonailSectionTestimonialElevensItem) => Partial<ComponentProps<"h3">>);
    testimonailSectionTestimonialElevensH4Props?: Partial<ComponentProps<"h4">> | ((item: TestimonailSectionTestimonialElevensItem) => Partial<ComponentProps<"h4">>);
    testimonailSectionFaSolidFaStarFilled1sItemWrapper?: (item: TestimonailSectionFaSolidFaStarFilled1sItem, content: ReactNode) => ReactNode;
    testimonailSectionFaSolidFaStarFilled1sRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonailSectionAuthorsItemWrapper?: (item: TestimonailSectionAuthorsItem, content: ReactNode) => ReactNode;
    testimonailSectionAuthorsRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonailSectionAuthorsImageVisible?: boolean;
    testimonailSectionAuthorsImageRenderer?: (item: TestimonailSectionAuthorsItem, defaultNode: ReactNode) => ReactNode;
    testimonailSectionAuthorsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonailSectionAuthorsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeElevenTestimonailSectionGenerated: FC<HomeElevenTestimonailSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Testimonials",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/arrow-left.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ImageWithBasePath1ImageAlt = "arrow",
    sectionDiv0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/arrow-right.svg",
    sectionDiv0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Our Testimonials",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/qutation-icon.png",
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "author",
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/reviews/author-3.png",
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt = "bg",
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/testimonial-img.png",
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    divDiv2H40H4Props,
    divImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0Slider0SliderProps,
    sectionDiv0Div1Div1Div0Slider1SliderProps,
    sectionDiv0Div1ClassName,
    testimonailSectionTestimonialElevens,
    testimonailSectionAuthors,
    testimonailSectionTestimonialElevensItemWrapper,
    testimonailSectionTestimonialElevensRenderer,
    testimonailSectionTestimonialElevensH3Visible,
    testimonailSectionTestimonialElevensH3Renderer,
    testimonailSectionTestimonialElevensH4Visible,
    testimonailSectionTestimonialElevensH4Renderer,
    testimonailSectionTestimonialElevensH3Props,
    testimonailSectionTestimonialElevensH4Props,
    testimonailSectionFaSolidFaStarFilled1sItemWrapper,
    testimonailSectionFaSolidFaStarFilled1sRenderer,
    testimonailSectionAuthorsItemWrapper,
    testimonailSectionAuthorsRenderer,
    testimonailSectionAuthorsImageVisible,
    testimonailSectionAuthorsImageRenderer,
    testimonailSectionAuthorsImageProps,
}) => {
    const [nav1, setNav1] = useState<Slider | null>(null);
    const [nav2, setNav2] = useState<Slider | null>(null);
    const sliderForSettings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: nav2 ?? undefined,
    };
    const sliderForRef = useRef<Slider | null>(null);
    const sliderNavSettings = {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        centerMode: true,
        centerPadding: "0px",
        focusOnSelect: true,
        infinite: true,
        variableWidth: true,
        speed: 1,
        asNavFor: nav1 ?? undefined,
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 1 },
            },
        ],
    };
    const sliderNavRef = useRef<Slider | null>(null);
    useEffect(() => {
        setNav1(sliderForRef.current);
        setNav2(sliderNavRef.current);
    }, []);
    return (
        <section className="testimonial-section-eleven section">
            <div className="container">
                <div className="section-header section-header-eleven text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid icon-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0ImageWithBasePath1ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid icon-2" {...(sectionDiv0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row align-items-center"}>
                    <div className="col-lg-5">
                        <div className="testimonial-left">
                            <div className="testimonial-author-slide">
                                <div className="testimonial-inner">
                                    {renderNode(sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid author-1" {...(sectionDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    <div className="icon">
                                        {renderNode(sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid icon" {...(sectionDiv0Div1Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                            {renderNode(sectionDiv0Div1Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div1Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid testimonial-bg" {...(sectionDiv0Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="testimonial-slider-eleven">
                            <Slider {...sliderForSettings} ref={sliderForRef} className="slider-for nav-center" {...(sectionDiv0Div1Div1Div0Slider0SliderProps ?? {})}>
                                {renderCollectionNode(
                                    testimonailSectionTestimonialElevens,
                                    (item: TestimonailSectionTestimonialElevensItem) => (
                                        <div className={item.className ?? "testimonial-item-eleven"} key={item.key}>
                                            <div className="rating">
                                                {renderCollectionNode(
                                                    item.ratingItems ?? [],
                                                    (item: TestimonailSectionFaSolidFaStarFilled1sItem) => (
                                                        <i className={item.className} key={item.key} />
                                                    ),
                                                    testimonailSectionFaSolidFaStarFilled1sItemWrapper,
                                                    testimonailSectionFaSolidFaStarFilled1sRenderer
                                                )}
                                                <span className="ms-2">5.0</span>
                                            </div>
                                            <div className={item.div1ClassName ?? "testimonial-content"}>
                                                {renderItemNode(testimonailSectionTestimonialElevensH3Visible, testimonailSectionTestimonialElevensH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof testimonailSectionTestimonialElevensH3Props === "function" ? testimonailSectionTestimonialElevensH3Props(item) : (testimonailSectionTestimonialElevensH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                ))}
                                                <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                            </div>
                                            <div className={item.div2ClassName ?? "author-name"}>
                                                {renderItemNode(testimonailSectionTestimonialElevensH4Visible, testimonailSectionTestimonialElevensH4Renderer, item, (
                                                    <h4 className={item.h40ClassName ?? "author"} {...(typeof testimonailSectionTestimonialElevensH4Props === "function" ? testimonailSectionTestimonialElevensH4Props(item) : (testimonailSectionTestimonialElevensH4Props ?? {}))} {...(typeof divDiv2H40H4Props === "function" ? divDiv2H40H4Props(item) : (divDiv2H40H4Props ?? {}))}>{item.h40Text}</h4>
                                                ))}
                                                <span className={item.span0ClassName ?? "designation"}>{item.span0Text}</span>
                                            </div>
                                        </div>
                                    ),
                                    testimonailSectionTestimonialElevensItemWrapper,
                                    testimonailSectionTestimonialElevensRenderer
                                )}
                            </Slider>
                            <Slider {...sliderNavSettings} ref={sliderNavRef} className="slider-nav nav-center" {...(sectionDiv0Div1Div1Div0Slider1SliderProps ?? {})}>
                                {renderCollectionNode(
                                    testimonailSectionAuthors,
                                    (item: TestimonailSectionAuthorsItem) => (
                                        <div className={item.className ?? "author-img"} key={item.key}>
                                            {renderItemNode(testimonailSectionAuthorsImageVisible, testimonailSectionAuthorsImageRenderer, item, (
                                                <SmartImage src={item.src} className={item.imageWithBasePath0ClassName ?? "img-fluid"} alt={item.alt} {...(typeof testimonailSectionAuthorsImageProps === "function" ? testimonailSectionAuthorsImageProps(item) : (testimonailSectionAuthorsImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    ),
                                    testimonailSectionAuthorsItemWrapper,
                                    testimonailSectionAuthorsRenderer
                                )}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeElevenTestimonailSectionGenerated;
